import React, { useRef, useState } from 'react'
import { Box, CardMedia, IconButton, Paper, Popover, Typography } from '@mui/material'
import { Preferito } from '../models/ServiceDescriptor'
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { useStartApplication } from './StartApplication';
import { useRecoilValue } from 'recoil';
import { CtxUfficioCorrenteType, userCtxUfficioCorrente } from '../atoms/portale';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useDeletePreferito, useEditPreferito } from '../atoms/preferito';
import { dndBorderActive, dndBorderInactive } from "../Constants"
import usePerfOrder from '../atoms/prefReorder';

type PreferredCardPropsType = {
    item: Preferito,
    preferiti: Preferito[],
    onMove: (newpref?: Preferito[]) => void,
}
const myColors = [
    'primary.main',
    'secondary.main',
    'error.main',
    'warning.main',
    'info.main',
    'success.main',
    'text.primary',
    'text.scondary',
    'text.disabled',
]

// const useEditPreferito = () => {
//     return (sd: ServiceDescriptor, preferito: Preferito) => {
//         console.log(`editPreferito: dovrei aprire l'editor: per sd: ${sd.id} preferito: ${preferito.id}`)

//     }
// }

export const PreferredCard: React.FC<PreferredCardPropsType> = ({ item, preferiti, onMove }) => {
    const startApplication = useStartApplication()
    const [anchorEl, setAnchorEl] = useState<any | null>(null);
    const [showInfo, setShowInfo] = useState(false)
    const editPreferito = useEditPreferito()
    const deletePreferito = useDeletePreferito()
    const dndref = useRef<HTMLDivElement>(null)
    const dnd = usePerfOrder(preferiti, dndref, item.id, 0.8, onMove)
    const handleInfo = (target: any) => {
        // console.log('handleInfo', item, target)
        setShowInfo(true);
        setAnchorEl(target);
    }
    const handleDelete = () => {
        const ans = window.confirm(`Vuoi eliminare il Preferito:\n\n${item.title}\n${item.descriUrl}`)
        if (ans) {
            // console.log(`Avendo risposto si dovrei eliminare il preferito...`)
            deletePreferito(item);
            
        }
    }
    dnd.drag(dnd.drop(dndref))

    const handleStartAppl = () => startApplication(item, true)
    const ufficioCorrente = useRecoilValue(userCtxUfficioCorrente)
    const iconName = `/icons/${item.iconName ?? '009-business presentation.svg'}`
    const color = item.color ?? myColors[item.id % 8]
    const handlePreferito = () => {
        // console.log('color in card', color)
        // console.log('iconName in card', iconName)
        editPreferito(item.serviceDescriptor, item, iconName?.substring(7), color)
    }
    // console.log(`PreferredCard: ${item.id} ${item.title} ${item.iconName} ${item.color} => ${iconName} - ${color}`)
    const getContestoDescri = (item: Preferito, ufficioCorrente?: CtxUfficioCorrenteType) => {
        if(item?.serviceDescriptor?.tipologiaSito === 'c' && !!!item.contesto) return 'Scelta Codice'
        return item.contesto ?? ufficioCorrente?.ufficioCorrente
    }
    // NOTA: il Box esterno è necessario per mettere il bordo che cambia colore con il drag and drop
    return (
        <Box sx={{
            borderRight: dnd.isInsertRight ? dndBorderActive : dndBorderInactive,
            borderLeft: dnd.isInsertLeft ? dndBorderActive : dndBorderInactive,
            px: '2px',
        }}>
            <Paper sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '16rem',
                width: '10.75rem',
                opacity: dnd.opacity,
            }}
            ref={dndref}
            >
                <ColorStrip color={color} />
                <IconStrip src={iconName} startAppl={handleStartAppl} />
                <TitleStrip>{item.title}</TitleStrip>
                <DescriStrip>{item.descriUrl}</DescriStrip>
                <ColorStrip>
                    {item.serviceDescriptor  
                        ? <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gap: 0.5,
                        }}>
                            {/* [{item.contesto ?? ufficioCorrente?.ufficioCorrente}] */}
                            [{getContestoDescri(item, ufficioCorrente)}]
                            {item.contesto ? <LocationOnIcon color='primary' fontSize="small" /> : <MyLocationIcon color='primary' fontSize='small' />}
                        </Box>
                        : <Box sx={{minHeigt: 20}}>&nbsp;</Box>
                    }
                </ColorStrip>
                <ActionStrip
                    onInfo={item.serviceDescriptor?.info ? handleInfo : undefined}
                    onDelete={!item.userId.match('@PROV@') ? handleDelete : undefined}
                    onSettings={!item.userId.match('@PROV@') ? handlePreferito : undefined}
                />
                <Popover
                    id='popover-positioned-top'
                    open={showInfo}
                    anchorEl={anchorEl}
                    onClose={() => setShowInfo(false)}
                    transitionDuration="auto"
                >
                    <Box sx={{ maxWidth: '400px', p: 1 }}>
                        <Typography sx={{ textAlign: 'center', my: 1, fontSize: '1.17rem', fontWeight: 800 }}>{item.serviceDescriptor?.urlDescription}</Typography>
                        <Box dangerouslySetInnerHTML={{ __html: item.serviceDescriptor?.info ?? '' }}></Box>
                    </Box>
                </Popover>
            </Paper>
        </Box>
    )
}

export const ColorStrip: React.FC<{ color?: string, children?: React.ReactNode }> = ({ color, children }) => {
    return (
        <Box sx={{
            minHeight: 8,
            bgcolor: color ?? '#e0e0e0',
            px: 1,
            flexGrow: 0,
            fontSize: 13,
        }}>{children}</Box>
    )
}
export const IconStrip: React.FC<{ src?: string, startAppl?: () => void }> = ({ src, startAppl }) => {
    const handleClick = (ev: React.MouseEvent<HTMLDivElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        startAppl && startAppl()
    }
    return (
        <Box sx={{
            flexGrow: 0,
            alignSelf: 'center',
            px: 3,
            py: 3,
            cursor: 'pointer',
            width: 146,
        }}
            onClick={handleClick}
        >
            <CardMedia component='img' src={src} />
        </Box>
    )
}
export const TitleStrip: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <Box sx={{
            px: 1,
            flexGrow: 0,
            fontSize: 13,
            fontWeight: 800,
            color: (theme) => theme.palette.secondary.dark
        }}>{children}</Box>
    )
}
export const DescriStrip: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <Box sx={{
            px: 1,
            mb: 0.5,
            flexGrow: 1,
            fontSize: 11,
        }}>{children}</Box>
    )
}
export const ActionStrip: React.FC<{ onInfo?: (target: any) => void, onDelete?: () => void, onSettings?: () => void }> = ({ onInfo, onDelete, onSettings }) => {
    const handleInfo = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        onInfo && onInfo(event.target)
    }
    const handleDelete = () => {
        onDelete && onDelete()
    }
    const handleSettings = () => {
        onSettings && onSettings()
    }
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 1,
            py: 0.5,
            flexGrow: 0,
            fontSize: 11,
        }}>
            {onInfo && <IconButton disabled={!onInfo} onClick={handleInfo} sx={{ width: 22, height: 22 }}><InfoIcon fontSize='small' /></IconButton>}
            <IconButton disabled={!onDelete} onClick={handleDelete} sx={{ width: 22, height: 22 }}><DeleteIcon fontSize='small' /></IconButton>
            <IconButton disabled={!onSettings} onClick={handleSettings} sx={{ width: 22, height: 22 }}><SettingsIcon fontSize='small' /></IconButton>
        </Box >
    )
}
